import { createContext, useCallback, useContext, useMemo, useState, type ReactNode } from 'react';

interface LoginDrawerContextValue {
  isOpen: boolean;
  openLoginDrawer: () => void;
  closeLoginDrawer: () => void;
}

const LoginDrawerContext = createContext<LoginDrawerContextValue | null>(null);

export function LoginDrawerProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);

  const openLoginDrawer = useCallback(() => setIsOpen(true), []);
  const closeLoginDrawer = useCallback(() => setIsOpen(false), []);

  const value = useMemo(
    () => ({ isOpen, openLoginDrawer, closeLoginDrawer }),
    [isOpen, openLoginDrawer, closeLoginDrawer]
  );

  return <LoginDrawerContext.Provider value={value}>{children}</LoginDrawerContext.Provider>;
}

export function useLoginDrawer(): LoginDrawerContextValue {
  const ctx = useContext(LoginDrawerContext);
  if (!ctx) {
    throw new Error('useLoginDrawer must be used within LoginDrawerProvider');
  }
  return ctx;
}
